module.exports = __webpack_public_path__ + "img/ECL_logo.5812254f.png";